import request from '@/utils/request'

const addressURl = {
  cacheSiteList: '/cache-manage/site-list',
  cacheSiteCreate: '/cache-manage/create-site',
  cacheSiteUpdate: '/cache-manage/update-site',
  cacheSiteDelete: '/cache-manage/delete-site',
  cacheSiteCheck: '/cache-manage/check-site',
  cacheSitePageList: '/cache-manage/site-page-list',
  cacheSitePageDetail: '/cache-manage/data-items',
  cacheSitePageCreate: '/cache-manage/create-site-page',
  cacheSitePageUpdate: '/cache-manage/update-site-page',
  cacheSitePageCheck: '/cache-manage/check-site-page',
  cacheSiteClear: '/cache-manage/clear',
  cacheSitePageDelete: '/cache-manage/delete-site-page'
}

// 缓存站点列表
export function cacheSiteList(data) {
  return request({
    url: addressURl.cacheSiteList,
    method: 'post',
    data
  })
}

// 新增缓存站点
export function cacheSiteCreate(data) {
  return request({
    url: addressURl.cacheSiteCreate,
    method: 'post',
    data
  })
}

// 编辑缓存站点
export function cacheSiteUpdate(data) {
  return request({
    url: addressURl.cacheSiteUpdate,
    method: 'post',
    data
  })
}

// 删除缓存站点
export function cacheSiteDelete(data) {
  return request({
    url: addressURl.cacheSiteDelete,
    method: 'post',
    data
  })
}

// 新增/编辑缓存站点域名校验
export function cacheSiteCheck(data) {
  return request({
    url: addressURl.cacheSiteCheck,
    method: 'post',
    data
  })
}

// 缓存站点-页面列表
export function cacheSitePageList(data) {
  return request({
    url: addressURl.cacheSitePageList,
    method: 'post',
    data
  })
}

// 缓存站点-页面详情
export function cacheSitePageDetail(data) {
  return request({
    url: addressURl.cacheSitePageDetail,
    method: 'post',
    data
  })
}

// 新增缓存站点页面
export function cacheSitePageCreate(data) {
  return request({
    url: addressURl.cacheSitePageCreate,
    method: 'post',
    data
  })
}

// 编辑缓存站点页面
export function cacheSitePageUpdate(data) {
  return request({
    url: addressURl.cacheSitePageUpdate,
    method: 'post',
    data
  })
}

// 新增/编辑缓存站点页面校验
export function cacheSitePageCheck(data) {
  return request({
    url: addressURl.cacheSitePageCheck,
    method: 'post',
    data
  })
}

// 清除缓存
export function cacheSiteClear(data) {
  return request({
    url: addressURl.cacheSiteClear,
    method: 'post',
    data
  })
}

// 删除缓存站点页面
export function cacheSitePageDelete(data) {
  return request({
    url: addressURl.cacheSitePageDelete,
    method: 'post',
    data
  })
}

export default {
  cacheSiteList,
  cacheSiteCreate,
  cacheSiteUpdate,
  cacheSiteDelete,
  cacheSiteCheck,
  cacheSitePageList,
  cacheSitePageDetail,
  cacheSitePageCreate,
  cacheSitePageUpdate,
  cacheSitePageCheck,
  cacheSiteClear,
  cacheSitePageDelete
}
